import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMinusCircle, faSearch } from "@fortawesome/free-solid-svg-icons";

const SearchContainer = styled.div`
                        background: white;
                        display: flex;
                        border: 1px solid #ced4da;
                        align-items: center;
                        padding-right: 10px;
                        .form-control {
                            border:0px;
                        }
`
const SearchSuggestions = styled.div`
                        background:#fff;
                        border-top:0px;
                        .mx-0{
                            border: solid 1px #ced4da;
                            border-top: 0px;
                        }    
                        .search-results{
                            min-height:186px;
                            max-height:186px;
                            background:#E8E8E8;
                            overflow:scroll;

                            ul{
                                li{
                                    display: flex;
                                    align-items: center;
                                  &:hover{
                                    color:#fff;
                                    background: #0184FE;
                                    cursor: pointer;
                                  }
                                }
                                li.disabled{
                                    color:#b5b5b5;
                                    &:hover{
                                        background: none;
                                        cursor: initial;
                                      }
                                }
                            }
                        }
                        .search-selected{
                            min-height:186px;  
                            background:#fff;
                            border-left: solid 1px #BCBCBB;
                            ul{
                                li{
                                    display: flex;
                                    align-items: center;

                                    &:hover{
                                        color:#fff;
                                        background: #0184FE
                                    }
                                    span{
                                        display:block;
                                        width:100%;
                                    }
                                    svg {
                                        float: right;
                                        display: none;
                                    }
                                }

                                li:hover {
                                    cursor:pointer;
                                    svg {
                                        display: block;
                                    }
                                }
                            }
                        }

                        ul{
                            list-style-type:none;
                            margin:0px;
                            padding:0px;
                            
                            li{
                                padding: 5px 15px;
                            }
                        }
                        
`;
const Search = (props) => {
    const [results, setResults] = useState(props.data);
    const [selected, setSelected] = useState(props.selected ? props.selected : []);

    const keyUp = (event) => {

        if (event.target.value === '') {
            setResults([]);
            return;
        }

        let searchResults = props.data.filter(item => item.name.toLowerCase().indexOf(event.target.value.toLowerCase()) !== -1);
        setResults(searchResults);
    }
    const addItem = (item) => {
        let index = selected.findIndex(x => x.name === item.name)

        if (index === -1) {

            let selectedItem = {};

            props.model.values.forEach((value, index) => {
                selectedItem[value] = item[value];
            });

            setSelected([...selected, selectedItem]);
        }
    }
    const removeItem = (item) => {
        let filteredUsers = selected.filter(user => user.name !== item.name);
        setSelected(filteredUsers);
    }
    const getItemName = (item) => {
        let name = '';
        props.model.title.forEach((value, index) => {
            name += (index !== 0 ? ' ' : '') + item[value];
        });

        return name;
    }
    useEffect(() => {
        props.onSelect(selected)
    }, [selected]);

    console.log(props);

    return (
        <div className="form-group">
            <label>{props.title}</label>
            <SearchContainer>
                <input type="text" className="form-control" id={props.id} placeholder="Search..." onKeyUp={keyUp} autoComplete="off" />
                <FontAwesomeIcon icon={faSearch} />
            </SearchContainer>
            {(results.length > 0) || (selected.length > 0) ?
                <SearchSuggestions>
                    <div className="row mx-0">
                        <div className="col-6 px-0">
                            <div className="w-100 px-2 py-2 search-results">
                                <ul>
                                    {props.id === 'owners' ?
                                        results.sort(function (a, b) {
                                            if (a.surname < b.surname) { return -1; }
                                            if (a.surname > b.surname) { return 1; }
                                            return 0;
                                        }).map((item, index) => (
                                            <li key={index} onClick={() => addItem({ ...item })} className={selected.findIndex(x => x.name === item.name) !== -1 ? 'disabled' : ''}> {getItemName(item)} </li>

                                        )) :

                                        results.map((item, index) => (
                                            <li key={index} onClick={() => addItem({ ...item })} className={selected.findIndex(x => x.name === item.name) !== -1 ? 'disabled' : ''}> {getItemName(item)} </li>

                                        ))


                                    }
                                </ul>
                            </div>
                        </div>
                        <div className="col-6 px-0">
                            <div className="w-100 px-2 py-2 search-selected">
                                <ul>
                                    {selected.map((item, index) => (
                                        <li key={index} onClick={() => { removeItem({ ...item }) }}><span>{getItemName(item)}</span> <FontAwesomeIcon icon={faMinusCircle} /></li>
                                    ))}
                                </ul>
                            </div>
                        </div>
                    </div>
                </SearchSuggestions> : ''}
            {props.warning ? <small id="{props.id}Warning" className="form-text activity-warning">{props.warning}</small> : ''}
        </div>
    );

}

export default Search